import LOL_0 from '~/assets/icons/LOL_0.png';
import LOL_1 from '~/assets/icons/LOL_1.png';
import LOL_2 from '~/assets/icons/LOL_2.png';
import LOL_3 from '~/assets/icons/LOL_3.png';
import LOL_4 from '~/assets/icons/LOL_4.png';
import LOL_5 from '~/assets/icons/LOL_5.png';
import LOL_6 from '~/assets/icons/LOL_6.png';
import LOL_7 from '~/assets/icons/LOL_7.png';
import LOL_8 from '~/assets/icons/LOL_8.png';

export const templatesImages = (t) => [
  {
    title: t('other:default'),
    component: LOL_0,
  },
  {
    title: t('other:template', { templateId: 1 }),
    component: LOL_1,
  },
  {
    title: t('other:template', { templateId: 2 }),
    component: LOL_2,
  },
  {
    title: t('other:template', { templateId: 3 }),
    component: LOL_3,
  },
  {
    title: t('other:template', { templateId: 4 }),
    component: LOL_4,
  },
  {
    title: t('other:template', { templateId: 5 }),
    component: LOL_5,
  },
  {
    title: t('other:template', { templateId: 6 }),
    component: LOL_6,
  },
  {
    title: t('other:template', { templateId: 7 }),
    component: LOL_7,
  },
  {
    title: t('other:template', { templateId: 8 }),
    component: LOL_8,
  },
];
